import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Picture from '../Shared/Picture';

class ArticleImageGallery extends Component {
    constructor(props) {
        super(props);
        this.state = {translateX: 0, slider: 1, stan: 50};
    }
    next(event) {
        event.preventDefault();
        let item = document.getElementsByClassName("inno-slider")[0];
        this.setState({
            slider: this.state.slider + 1,
            stan: this.state.stan + 25
        }, () => {
            this.setState({
                translateX: "translateX(-"+ this.state.stan+ "%)",
            }, () =>{
                item.style.transform = this.state.translateX;
            })
        })
    }
    prev(event) {
        event.preventDefault();
        let item = document.getElementsByClassName("inno-slider")[0];
        this.setState({
            slider: this.state.slider - 1,
            stan: this.state.stan - 25
        }, () => {
            this.setState({
                translateX: "translateX(-"+ this.state.stan+ "%)",
            }, () =>{
                item.style.transform = this.state.translateX;
            })
        })
    }
    render() {
        const {
            ImageGallery
        } = this.props.article;
        return (
            <div className="inno-slider-wrapper teaser-media shadow shadow-blue">
                <ul className="inno-slider">
                {ImageGallery.length > 0 ? (
                    ImageGallery.map((image) => {
                        return <li className="inno-slider-item">
                            <Picture src={image.Image.Value} alt={image.ImageAlt.Value} />
                        </li>
                    })
                ) : null}
                </ul>
                <nav className="inno-slider-nav">
                {this.state.slider > 0 ? (<a href="" onClick={(event) => {this.prev(event)}} className="prev ir">prev</a>) : null}
                {this.state.slider < 2 ? (<a href="" onClick={(event) => {this.next(event)}} className="next ir">next</a>) : null}
                </nav>
            </div>
        )
    }
}
ArticleImageGallery.propTypes = {
    ImageGallery: PropTypes.array.isRequired
}
export default ArticleImageGallery;